// Card #1640 (design §8.2/§8.3) — a theme's logo slots each carry a size
// key (small/medium/large); this is the one place that maps those labels to
// a concrete height, shared by the theme editor's config page (§8.3, picker
// + live preview) and the actual board (ScoreboardFrame, §8.4 application).
//
// vh-based rather than px: every other ScoreboardFrame.css dimension
// (1.5vh/1.5vw slot offsets, the 2vw loading text) is viewport-relative so
// the board scales consistently from a small kiosk monitor up to a big
// arena TV — a fixed px height would look wildly different in scale between
// the two.
export const LOGO_SIZES = ["small", "medium", "large"];

export const DEFAULT_LOGO_SIZE = "medium";

export const LOGO_SIZE_HEIGHT_VH = {
  small: 4,
  medium: 7,
  large: 11,
};

export const LOGO_SIZE_LABELS = {
  small: "Small",
  medium: "Medium",
  large: "Large",
};

// Unrecognized/absent size keys fall back to the default height rather than
// rendering unsized (which, per ScoreboardFrame's current object-fit:
// contain + no explicit height, would just show the image at its raw pixel
// size — unpredictable across upload resolutions).
export function logoHeightVh(size) {
  return LOGO_SIZE_HEIGHT_VH[size] ?? LOGO_SIZE_HEIGHT_VH[DEFAULT_LOGO_SIZE];
}
